export default __webpack_public_path__ + "static/media/Eye_4_M_C5.ee0274d8.svg";